import { useState, useEffect, useRef } from "react";
import { Spinner, Alert } from "react-bootstrap";

function LoadScreen({
  loading, setLoading}) {

  useEffect(() => {
    
  }, []);

  return (<>
    {loading&&<div className="load-screen">
      <div>
          {loading === "error" && (
            <Alert key="danger" className="m-0" variant="danger">
              Fehler!
            </Alert>
          )}
          {loading === "success" && (
            <Alert key="success" className="m-0" variant="success">
              Speichern erfolgreich!
            </Alert>
          )}
          
                {loading === "loading" && ( <Spinner
                  /* as="span" */
                  animation="border"
                  size="lg"
                  role="status"
                  aria-hidden="true"
                />)}
                </div>
          </div>}</>
  );
}

export default LoadScreen;
